import { CurvedLineCharts } from "@/src/components/CommonCharts/CurvedLineCharts";
import styles from "../Stats.module.css";
export const PlayerProfitGraph = ({ profitGraph, chartDataConfig }) => {
  if (!profitGraph || Object.keys(profitGraph).length === 0) return null;
  return (
    <div className={`flex flex-col ${styles.cardConfig} gap-[3px] mb-[12px]`}>
      <div className="graph-title text-center text-secondary">
        {profitGraph.chartTitle}
      </div>
      <CurvedLineCharts
        chartCls="h-[207px]"
        chartDataConfig={chartDataConfig}
        chartData={profitGraph.data}
      />
    </div>
  );
};
